import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { request_logout } from '../redux/actions';
import './AccountPage.css';
import {Link} from 'react-router-dom';
import ListaAvistamentos from './ListaAvistamentos';

function AccountPage(){
    const dispatch = useDispatch();
    const userData = useSelector(state => state.userStatus.profile)
    const avistamentos = useSelector(state => state.avistamentosUser.avistamentos)
    const [observacoes, setObservacoes] = useState(0)

    useEffect(() => {
        

        const summer = () => {
            if(avistamentos.length !==0){
                return avistamentos[0].properties.id_user.n_animais + avistamentos[0].properties.id_user.n_ninhos + avistamentos[0].properties.id_user.n_ataques
            }
         
     
            return 0
        }
        setObservacoes(summer())
        
    }, [avistamentos]);

    return(
        <div className='page-body'>
            <div
                className='user-info' 
            >
                
                    <img
                        className='user-image'
                        src={`/app/avatars/avatar${userData.avatar}.png`}
                        
                    />
                    <div className='user-info-text'>
                        <div >
                            {userData.email}
                        </div>
                        <div style={{fontSize:20}}>{observacoes} observações</div>
                        <Link to={'/minha-conta/editar-avatar'} style={{color:'blue', cursor: 'pointer', textAlign: 'center', textDecoration:'none'}}>Editar avatar</Link>
                        {userData.role==='Administrador' ? <Link to={'/validar'} style={{color:'blue', cursor: 'pointer', textAlign: 'center', textDecoration:'none'}}><div>Validar</div></Link>:null}
                        {userData.role==='Administrador' ? <Link to={'/admin'} style={{color:'blue', cursor: 'pointer', textAlign: 'center', textDecoration:'none'}}><div>Administração</div></Link>:null}
                        <Link to={'/minha-conta/alterar-password'} style={{color:'blue', cursor: 'pointer', textAlign: 'center', textDecoration:'none'}}>Alterar password</Link>
                        <div>
                            <div style={{color:'red', cursor: 'pointer', textAlign: 'center', textDecoration:'none', marginTop:'10px'}} onClick={() => dispatch(request_logout())}>Terminar sessão</div>
                        </div>
                        
                        
                    </div>
                
                    
            </div>
        
                <ListaAvistamentos tipo = 'utilizador' n_obs = {observacoes}/>   
                    
            </div>
        
    )
   
    
    

    
}

export default AccountPage;